import { combineReducers } from 'redux';
import { outboundReportsReducer } from './OutboundReportsReducer';
import { reportsReducer } from './ReportsReducer';

export default combineReducers({
  outbound: outboundReportsReducer,
  reports: reportsReducer,
});
